import { mapGetters } from 'vuex'
import Configuration from '@/agilis/util/Configuration'
import FormSelectMultiple from '@/agilis/components/Form/FormSelectMultiple/FormSelectMultiple.vue'
import FormTree from '@/agilis/components/Form/FormTree/FormTree.vue'
import L from 'lodash'

export default {
  name: 'DashboardFilter',
  props: {
    filters: Object,
    context: Object,
    title: String,
    styleConfig: Object
  },

  data () {
    return {
      formCustomComponents: {
        FormSelectMultiple,
        FormTree
      },
      filterModel: {},
      activeFilters: 0,
      reveal: false
    }
  },

  computed: {
    ...mapGetters({
      applicationId: 'contextStore/applicationId'
    }),

    computedTitle () {
      return this.$t(this.title, this.context)
    },

    styleClasses () {
      const styles = []
      const decorations = this.styleConfig || {}
      for (const style in decorations) {
        const decoration = decorations[style] // appendiamo le classi css, per ora senza gestione logiche
        styles.push(decoration)
      }

      return styles.join(' ')
    },

    filterRows () {
      return this.filters.filterRows
    },

    filterFields () {
      return this.filters.filterTerms.reduce((acc, filterTerm) => {
        let filterField = null
        if (filterTerm.trackerTypeId) {
          const dataTable = Configuration.datatable.getDatatable({
            applicationId: this.applicationId,
            trackerTypeId: filterTerm.trackerTypeId
          })
          filterField = L.merge({}, dataTable?.columns?.[filterTerm.id], filterTerm)
        } else {
          filterField = L.cloneDeep(filterTerm)
        }

        filterField.hideDetails = true
        filterField.clearable = true
        delete filterField['operator']

        acc[filterTerm.id] = filterField

        return acc
      }, {})
    }
  },

  methods: {
    applyFilters () {
      const context = L.cloneDeep(this.context)
      const newFilterTerms = this.filters.filterTerms.map((filterTerm) => {
        return {
          field: filterTerm.id,
          operator: filterTerm.operator,
          value: this.filterModel[filterTerm.id]
        }
      })
      const newFilterArray = L.unionWith(newFilterTerms, context.filterArray,
        function (value, other) {
          return value.field === other.field
        }
      )
      context.filterArray = newFilterArray.filter(f => !!f.value)
      this.$emit('update-context', context)

      this.activeFilters = Object.keys(this.filterModel).filter((key) => {
        return this.filterModel[key]
      }).length
    },

    clearFilters () {
      Object.keys(this.filterModel).forEach((key) => {
        this.filterModel[key] = null
      })
      this.applyFilters()
    }
  }
}
